import React , {useState , useEffect , Fragment} from "react";
import classNames from 'classnames' ;
import FileUploader from "./FileUploader";
import Select, {components} from 'react-select';
import JalaliDatePicker from "./JalaliDatePicker";

export const selectStyle = {
    control: styles => ({
        ...styles,
        border: 'none',
        backgroundColor: '#F1F1F1',
        marginTop: '0.25rem',
        fontFamily: 'roboto, IRANSans-web, Arial !important'
    }),
    indicatorSeparator: styles => ({...styles, display: 'none'}),
};

export const simpleInputField = ({
                                     input,
                                     label,
                                     required = true,
                                     type,
                                     meta: {touched, error, warning , active}
                                 }) => {
    return (
        <Fragment>
            <div className={classNames("inputContainer title" , {"active" : active || input.value})}>
                <label>{label}</label>
                <input {...input} className="standardInput" type={type || "text"} />
                {error  && touched ? <span className="redColor rightFloat">{error}</span> : null}
            </div>
        </Fragment>

    );
};

export const inputWithUnit = ({
                                  input,
                                  label,
                                  unit,
                                  required = true ,
                                  meta: {touched, error, warning , active}
                              }) => {
    return (
        <div className={classNames("inputContainer price withUnit" , {"active" : active || input.value})}>
            <span className="unit">تومان</span>
            <label>{label}</label>
            <input {...input} className="standardInput" />
            {error && touched ? <span className="redColor rightFloat">{error}</span> : null}
        </div>
    );
};

export const selectField = ({input: {value, onChange}, label, options, meta: {touched, error, warning , active}}) => {
    return (
        <Fragment>
            <div className={classNames("inputContainer publisher" , {"active" :active || value})}>
                <label>{label}</label>
                <Select
                    value={value}
                    onChange={onChange}
                    options={options}
                    styles={selectStyle}
                />
                {error && touched ? <span className="redColor rightFloat">{error}</span> : null}
            </div>
        </Fragment>
    );
};

export const uploadFileField = ({input: {value, onChange}, label, options, placeholder, meta: {touched, error, warning}}) => {
    return (
        <Fragment>
            <div className="bookCoverUpload">
            <FileUploader value={value} onChange={onChange}/>
            </div>
            {error && touched ? <span className="redColor rightFloat">{error}</span> : null}
        </Fragment>
    );
};

export const textAreaField = ({
                                  input,
                                  label,
                                  required = true ,
                                  meta: {touched, error, warning , active}
                              }) => {
    return (
        <div className={classNames("inputContainer description" , {"active" : active || input.value})}>
            <label>{label}</label>
            <textarea {...input} className="standardInput"></textarea>
            {error && touched ? <span className="redColor rightFloat">{error}</span> : null}
        </div>
    );
};

export const jalaliDatePickerField = ({
                                     input,
                                     label,
                                     required = true,
                                     type,
                                     meta: {touched, error, warning , active}
                                 }) => {
    return (
        <Fragment>
            <div className={classNames("inputContainer title" , {"active" : active || input.value})}>
                <label>{label}</label>
                <JalaliDatePicker {...input} />
                {error  && touched ? <span className="redColor rightFloat">{error}</span> : null}
            </div>
        </Fragment>

    );
};